export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('operators');
    if (element) {
        if (element.length) {
            tourCriteriaJson.operators = element.pluck('id');
        } else {
            tourCriteriaJson.operators = [];
        }
    }

    return tourCriteriaJson;
};